import Splash from "../components/Splash";
import Login from "../components/Login/Login";
import Verify from "../components/Login/Verify";
import Home from "../components/Home/Home";
import Requests from "../components/Requests/Requests";
import HomeRequests from "../components/Home/Requests";
import Profile from "../components/Profile/Profile";
import Request from "../components/Requests/Request";
import HomeRequest from "../components/Home/Request";
import EditProfile from "../components/Profile/EditProfile";
import OwnersList from "../components/Home/OwnersList";
import Owner from "../components/Home/Owner";
import UsersList from "../components/Home/UsersList";
import ManageWallet from "../components/Home/ManageWallet";
import ReagentRequests from "../components/Home/ReagentRequests";
import ReagentRequestProfile from "../components/Requests/ReagentRequestProfile";


const appRoutes = [
    {
        id : '0',
        path : '/',
        component : Splash
    },
    {
        id : '1',
        path : '/login',
        component : Login
    },
    {
        id : '2',
        path : '/verify',
        component : Verify
    },
    {
        id : '3',
        path : '/home/:page',
        component : HomeRequests
    },
    {
        id : '4',
        path : '/requests',
        component : Requests
    },
    {
        id : '4',
        path : '/profile',
        component : Profile
    },


    {
        id : '5',
        path : '/request/:id',
        component : Request
    },


    {
        id : '50',
        path : '/report/:id',
        component : HomeRequest
    },


    {
        id : '6',
        path : '/edit-profile',
        component : EditProfile
    },

    {
        id : '7',
        path : '/home',
        component : HomeRequests
    },

    {
        id : '70',
        path : '/completed',
        component : Home
    },
    {
        id : '8',
        path : '/owners',
        component : OwnersList
    },
    {
        id : '9',
        path : '/owners/:id',
        component : Owner
    },

    {
        id : '10',
        path : '/users-wallet',
        component : UsersList
    },
    {
        id : '11',
        path : '/users-wallet/:id',
        component : ManageWallet
    },
    {
        id : '12',
        path : '/reagent-requests',
        component : ReagentRequests
    },
    {
        id : '13',
        path : '/reagent-requests/:id',
        component : ReagentRequestProfile
    },

];
export default appRoutes;